import channel from './channel';
import contacts from './contacts';
import download from './download';
import errors from './errors';
import layout from './layout';
import notification from './notification';
import pending from './pending';
import route from './route';
import session from './session';
import transfer from './transfer';
import transfers from './transfers';
import transfersReceived from './transfers-received';
import upload from './upload';
import user from './user';
import account from './account';
import ui from './ui';
import invoices from './invoices';
import apiGrants from './apigrants';
import billingDetails from './billingdetails';
import consent from './consent';

import transferUpload from '@app/transfer-bundle/store/reducer';

export default {
  channel,
  contacts,
  download,
  errors,
  layout,
  notification,
  pending,
  route,
  session,
  transfer,
  transfers,
  transfersReceived,
  upload,
  user,
  account,
  ui,
  invoices,
  apiGrants,
  billingDetails,
  transferUpload,
  consent,
};
